// Splash mínimo mientras MSAL se inicializa (handleRedirectPromise resuelve
// el callback de Microsoft). Mantiene la marca y evita parpadeos.

import { html } from 'htm/preact'

export function LoadingScreen({ message = 'Validando sesión…' }) {
  return html`
    <div class="auth-screen">
      <div class="auth-card">
        <img
          class="auth-card__logo"
          src="/logos/jma-cybersec-horizontal.png"
          alt="JMA CyberSec"
        />
        <h1 class="auth-card__title">Dashboard JMA AFAC</h1>
        <p class="auth-card__subtitle">${message}</p>
      </div>
    </div>
  `
}
